import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Icons } from '@curves/ui-base';

/** 依實際／預期數量回傳應驗收儲存格 className，供 getCellClassName 使用 */
export const getExpectedQuantityCellClassName = (actualQuantity, expectedQuantity) => {
	const actual = actualQuantity ?? 0;
	const expected = expectedQuantity ?? 0;
	if (expected === 0) return "";
	const isMatch = actual === expected;
	const isLess = actual < expected;
	const isMore = actual > expected;
	return isMatch ? "inspection-qty-match" : isLess ? "inspection-qty-less" : isMore ? "inspection-qty-more" : "";
};

// 功能：驗收數量顯示（actual/expected），並提供點擊編輯入口
const ExpectedQuantityCell = ({ actualQuantity, expectedQuantity, item, onOpenQuantityEdit, showCheckIcon }) => {
	const actual = actualQuantity ?? 0;
	const expected = expectedQuantity ?? 0;

	if (expected === 0 && showCheckIcon) {
		return <Icons.Check color="success" />;
	}

	const handleClick = (e) => {
		e.stopPropagation();
		if (onOpenQuantityEdit) onOpenQuantityEdit(item);
	};

	return (
		<Box onClick={onOpenQuantityEdit ? handleClick : undefined} style={{ cursor: onOpenQuantityEdit ? "pointer" : "default" }}>
			<Typography
				className='actual-qty'
				component="span"
			>
				{actual}
			</Typography>
			<Typography component="span" className="font-color-3">
				{" "}/ {expected}
			</Typography>
		</Box>
	);
};

ExpectedQuantityCell.propTypes = {
	actualQuantity: PropTypes.number,
	expectedQuantity: PropTypes.number,
	item: PropTypes.object.isRequired,
	onOpenQuantityEdit: PropTypes.func,
	showCheckIcon: PropTypes.bool,
};

export default ExpectedQuantityCell;
